import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import { updatePassword } from "../../service/UserApi"; // Your API function to update password
import { Helmet } from "react-helmet-async";
import { Navbar, Footer, Breadcrumbs } from "../../components/shared";
import useCheckLoggedin from "../../utils/useCheckLoggedin";
import { useSelector } from "react-redux";
const UserProfileSetPassword = () => {
    useCheckLoggedin(); // Check if the user is logged in (if no user data, redirect to login)
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");
    const [successMessage, setSuccessMessage] = useState("");
    const navigate = useNavigate();
    const { register, handleSubmit, formState: { errors }, reset, getValues } = useForm();

    const loggedInUserEmail = useSelector((state) => state.user.email);

    // Handle password update form submission
    const handlePasswordSubmit = async (data) => {
        const { newPassword } = data;

        setLoading(true);
        setError("");
        setSuccessMessage("");

        try {
            // Call the API to update the password
            const response = await updatePassword({
                email: loggedInUserEmail,
                newPassword
            });

            if (response === true) {
                setSuccessMessage("கடவுச்சொல் வெற்றிகரமாக புதுப்பிக்கப்பட்டது.");
                reset(); // Clear form fields
                setTimeout(() => {
                    navigate(`/auth/logout?logoutType=lite-logout`);
                }, 2000);
            } else {
                setError(response.message || "புதுப்பிப்பதில் பிழை, தயவுசெய்து மீண்டும் முயற்சிக்கவும்.");
            }

        } catch (err) {
            setError(`புதுப்பிப்பதில் பிழை: ${err.message}`);
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            <Navbar />
            <Helmet>
                <title>ஸ்ரீ பொன்னாச்சி அம்மன் திருக்கோவில்கள் | கடவுச்சொல் புதுப்பிக்கவும்</title>
                <link rel="canonical" href="/user/set-password" />
            </Helmet>
            <div className="general_parent">
                <div className="general_container">
                    <div className="general_body">
                        <Breadcrumbs /><br />
                        <h3>கடவுச்சொல் புதுப்பிக்கவும்</h3>
                        <br />
                        <form onSubmit={handleSubmit(handlePasswordSubmit)} className="auth_form">
                            <div className="auth_element">
                                <label className="auth_label">புதிய கடவுச்சொல் 🔒</label>
                                <input
                                    type="password"
                                    {...register("newPassword", {
                                        required: "புதிய கடவுச்சொல் தேவை.",
                                        minLength: {
                                            value: 8,
                                            message: "கடவுச்சொல் குறைந்தது 8 எழுத்துகள் வேண்டும்.",
                                        },
                                        pattern: {
                                            value: /^(?=.*[a-zA-Z])(?=.*[0-9]).{8,}$/,
                                            message: "எழுத்தும் எண்ணும் இருக்க வேண்டும் (சிறப்பு எழுத்துகள் கூடலாம்)",
                                        },
                                    })}
                                    className="auth_input"
                                    placeholder="புதிய கடவுச்சொல்"
                                    autoComplete="off"
                                />
                                <div className="auth_label">
                                    குறைந்தபட்சம் 8 எழுத்துகள், ஒரு எழுத்தும் ஒரு எண்ணும் கட்டாயம். சிறப்பு எழுத்துகள் (@, #, !) கூடலாம்.
                                </div>
                                {errors.newPassword && <div className="auth_error">{errors.newPassword.message}</div>}
                            </div>

                            <div className="auth_element">
                                <label className="auth_label">புதிய கடவுச்சொல் (சரிபார்க்கவும்)</label>
                                <input
                                    type="password"
                                    {...register("confirmPassword", {
                                        required: "புதிய கடவுச்சொல் மீண்டும் தேவையானது.",
                                        validate: (value) => value === getValues('newPassword') || "புதிய கடவுச்சொல் பொருந்தவில்லை",
                                    })}
                                    className="auth_input"
                                    placeholder="புதிய கடவுச்சொல் (சரிபார்க்கவும்)"
                                    autoComplete="off"
                                />
                                {errors.confirmPassword && <div className="auth_error">{errors.confirmPassword.message}</div>}
                            </div>

                            {error && <div className="auth_error">{error}</div>}
                            {successMessage && <div className="auth_success">{successMessage}</div>}

                            <button type="submit" className="auth_submit" disabled={loading}>
                                {loading ? "சமர்ப்பிக்கின்றது..." : "கடவுச்சொல் புதுப்பிக்கவும்"}
                            </button>
                        </form>
                        <br />
                        <button onClick={() => navigate("/user/profile")}>என் கணக்கிற்குச் செல் 👤</button>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    );
};

export default UserProfileSetPassword;
